import { createRoute } from "../../../utils";

import { booksRoutesObj, booksBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const booksRouteMetadata: IRouteMetadataObj<typeof booksRoutesObj> = {
  list: {
    title: "booksList",
    lazy: () =>
      import("@/pages/facultyMemberPanel/articlesAndBook/book/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewBook",
    lazy: () =>
      import("@/pages/facultyMemberPanel/articlesAndBook/book/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editBookOf",
    lazy: () =>
      import("@/pages/facultyMemberPanel/articlesAndBook/book/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewBookOf",
    lazy: () =>
      import("@/pages/facultyMemberPanel/articlesAndBook/book/form/page"),
    mode: "view",
    permission,
  },
};

export const bookRoutes = createRoute<typeof booksRoutesObj>(
  booksRoutesObj,
  booksRouteMetadata,
  booksBreadcrumbs,
);
